module.exports = __webpack_public_path__ + "img/norway-tuberculosis-female.7b71ce4f.png";